<div>
    <mat-paginator *ngIf="paginator" #paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 20]" [length]="subject?.length" (page)="changePage($event)"></mat-paginator>
    <table mat-table matSort [dataSource]="labos" class="labo-table">
        <ng-container matColumnDef="labo">
            <th mat-header-cell *matHeaderCellDef style="display: none;"></th>
            <td mat-cell *matCellDef="let labo">
                <app-labo-row [record]="labo" [mode]="'full'"></app-labo-row>
            </td>
        </ng-container>
        <tr class="hide-header" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>